"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AssertionError_1 = require("../error/AssertionError");
const EtudeError_1 = require("../error/EtudeError");
const EtudeParser_1 = require("../util/EtudeParser");
const Exceptional_1 = require("../util/Exceptional");
class Accidental {
    constructor(symbol, offset) {
        this.symbol = symbol;
        this.offset = offset;
        ++Accidental.size;
        Accidental._values.push(this);
    }
    static values() {
        return Accidental._values.slice();
    }
    ordinal() {
        return Accidental._values.indexOf(this);
    }
    static valueOf(accidentalString) {
        const accidental = Accidental[accidentalString];
        if (accidental instanceof Accidental) {
            return accidental;
        }
        throw EtudeError_1.default.forInvalid(Accidental, accidentalString);
    }
    static isValid(value) {
        if (typeof (value) === "number") {
            const offset = value;
            return Accidental.TRIPLE_FLAT.getOffset() <= offset && offset <= Accidental.TRIPLE_SHARP.getOffset();
        }
        else if (typeof (value) === "string") {
            const accidentalString = value;
            return Accidental
                .values()
                .map(a => a.toString())
                .some(a => accidentalString.localeCompare(a) === 0);
        }
        else {
            throw new AssertionError_1.default("Should not have reached else statement.");
        }
    }
    static fromOffset(offset) {
        return Exceptional_1.default
            .of(offset)
            .filter(o => Accidental.isValid(o), EtudeError_1.default.forInvalid(Accidental, offset, "out of range"))
            .map(i => Accidental.values()[i - Accidental.TRIPLE_FLAT.getOffset()]);
    }
    getOffset() {
        return this.offset;
    }
    static fromString(accidentalString) {
        return EtudeParser_1.default
            .of(accidentalString)
            .filter(o => o != null, EtudeError_1.default.forNull(Accidental))
            .parse(s => {
            const value = Accidental
                .values()
                .find(a => s.localeCompare(a.toString()) === 0);
            return Exceptional_1.default
                .ofNullable(value)
                .withException(EtudeError_1.default.forInvalid(Accidental, s));
        })
            .get(a => a[0]);
    }
    toString() {
        return this.symbol;
    }
}
Accidental.size = 0;
Accidental._values = [];
Accidental.TRIPLE_FLAT = new Accidental("bbb", -3);
Accidental.DOUBLE_FLAT = new Accidental("bb", -2);
Accidental.FLAT = new Accidental("b", -1);
Accidental.NATURAL = new Accidental("n", 0);
Accidental.SHARP = new Accidental("#", 1);
Accidental.DOUBLE_SHARP = new Accidental("x", 2);
Accidental.TRIPLE_SHARP = new Accidental("#x", 3);
exports.default = Accidental;
